import AnimatedNumber from '@/components/utilities/AnimatedNumber';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const StatsTable = ({ statsTableContent: content }) => {
  return (
    <div className="flex flex-wrap justify-center">
      {(content || []).map((item, index) => (
        <VisibleLoading key={item.id} delay={(index + 1) * 200}>
          {({ ref, className, isVisible }) => (
            <div
              ref={ref}
              className={`flex basis-full flex-col items-center border-t-1 border-black/20 px-5 py-8 first:border-t-0 first:border-l-0 xl:basis-1/3 xl:border-t-0 xl:border-l-1 ${className || ''}`.trim()}
            >
              <h2 className="mb-6">
                <AnimatedNumber value={item.value} isVisible={isVisible} delay={700 + (index + 1) * 200} />
                {item.unit ? ` ${item.unit}` : ''}
              </h2>
              <div className="txt-xl text-center font-medium text-black">{item.label}</div>
            </div>
          )}
        </VisibleLoading>
      ))}
    </div>
  );
};
export default StatsTable;
